import React, { Component } from 'react';

class FullScreenForm extends Component {
    _submit = e => {
        e.preventDefault();
        if (this.props.canSubmit) {
            this.props.onSubmit();
        }
    };
    render() {
        return (
            <form onSubmit={this._submit} className="ckp-forms">
                <header className="ckp-forms-header">
                    <h1 className="ckp-ts-h1">{this.props.header}</h1>
                </header>
                <div className="ckp-forms-body">{this.props.body}</div>
                <footer className={`ckp-forms-footer ${this.props.withCancel ? 'is-with-cancel' : ''}`}>
                    {this.props.footer}
                </footer>
            </form>
        );
    }
}

export default FullScreenForm;
